import { render, staticRenderFns } from "./onRemark.vue?vue&type=template&id=15bd1ec0&scoped=true"
import script from "./onRemark.vue?vue&type=script&lang=js"
export * from "./onRemark.vue?vue&type=script&lang=js"
import style0 from "./onRemark.vue?vue&type=style&index=0&id=15bd1ec0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bd1ec0",
  null
  
)

export default component.exports